import { isDateInRange } from 'app/utils/date';

/**
 * Недели, которые нельзя выбрать ни в одном селекте доставки.
 * Значения — это period.start из menuSidebar.periods (YYYY-MM-DD).
 * Нужно для всех мест, где рендерится список недель/периодов:
 * mobileDeliveryDateSelectPopup, MobilePeriodSelectContainer, PeriodList.
 */
export const HIDDEN_PERIOD_STARTS = [
    '2026-12-28',
];

/**
 * Страницы (фрагменты pathname), на которых скрытие дат отключено.
 * Добавление страницы = одна строка, матчинг через pathname.includes(path).
 * @example '/profile/'
 */
export const HIDDEN_DATES_EXCLUDED_PATHS = [
    '/blyuda-dlya-novogodnego-stola',
];

const HIDDEN_PERIODS_RANGE_IN_DAYS = 1;

const HIDDEN_PERIOD_LENGTH_IN_DAYS = 7;

const ONE_DAY_IN_MS = 1000 * 60 * 60 * 24;

/**
 * @description сверяет со списком скрытых недель с учетом смещения на 1 день у региональных циклов,
 * поэтому 2026-10-12 скрывает и 2026-10-11, и 2026-10-13
 */
export const isPeriodHidden = (periodStart) => HIDDEN_PERIOD_STARTS
    .some((hiddenStart) => isDateInRange(hiddenStart, periodStart, HIDDEN_PERIODS_RANGE_IN_DAYS));

/**
 * @description дата попадает в скрытую неделю: от start - 1 до start + 6 + 1,
 * крайние дни смещены из-за региональных циклов (как в isPeriodHidden)
 */
export const isDateHidden = (isoDate) => {
    const target = new Date(isoDate);

    if (Number.isNaN(target.getTime())) return false;

    return HIDDEN_PERIOD_STARTS.some((hiddenStart) => {
        const start = new Date(hiddenStart);
        const diffInDays = (target - start) / ONE_DAY_IN_MS;

        return diffInDays >= -HIDDEN_PERIODS_RANGE_IN_DAYS
            && diffInDays <= HIDDEN_PERIOD_LENGTH_IN_DAYS - 1 + HIDDEN_PERIODS_RANGE_IN_DAYS;
    });
};

/**
 * @description текущая страница входит в список страниц-исключений,
 * на которых скрытие дат работать не будет
 */
export const isHiddenDatesExcludedOnPage = () => {
    if (typeof window === 'undefined') return false;

    const { pathname } = window.location;

    return HIDDEN_DATES_EXCLUDED_PATHS.some((excludedPath) => pathname.includes(excludedPath));
};

/**
 * @description убирает скрытые недели из списка периодов
 */
export const excludeHiddenPeriods = (periods = []) => (
    (periods || []).filter((period) => !isPeriodHidden(period?.start))
);

/**
 * @description убирает даты скрытых недель из списка дат (формат DateSelect, ISO в поле date),
 * кроме страниц-исключений и кроме выбранной даты
 */
export const filterHiddenDates = (dates, selectedDate) => {
    const visibleDates = dates || [];

    if (isHiddenDatesExcludedOnPage()) return visibleDates;

    return visibleDates.filter((item) => (
        item?.date === selectedDate || !isDateHidden(item?.date)
    ));
};
